// **********************************************************
// Image Gallery
// **********************************************************

const imageGallery = document.querySelectorAll('[data-slider="image-gallery-slider"]');

const imageGalleryOptions = {
  slidesPerView: 'auto',
  spaceBetween: 20,
  centeredSlides: true,
  breakpoints: {
    767: {
      centeredSlides: false,
      slidesPerView: 'auto',
      spaceBetween: 25,
    },
    1023: {
      centeredSlides: false,
      slidesPerView: 'auto',
      spaceBetween: 30,
    },
    1199: {
      centeredSlides: false,
      slidesPerView: 'auto',
      spaceBetween: 40,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

imageGallery.forEach((el) => {
  const imageGalleryEle = el.closest('.image-gallery');

  const arrowRight = imageGalleryEle.querySelector('.arrow-right');
  const arrowLeft = imageGalleryEle.querySelector('.arrow-left');

  imageGalleryOptions.navigation.nextEl = arrowRight;
  imageGalleryOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-new
  new Swiper(el, imageGalleryOptions);
});
